import { gql } from "@apollo/client";

export const GET_APPLICATION_STATUS = gql`
  query VaultAccountStatus(
    $provider: VaultFinancialProvider!
    $applicationId: ID
  ) {
    vaultAccountStatus(provider: $provider, applicationId: $applicationId) {
      accountRepresentativeRequirements {
        missingFields
        requiredDocuments
        requiredDocumentIds
        requiredDocumentOwnerNames
      }
      beneficialOwnersRequirements {
        missingFields
        requiredDocuments
        requiredDocumentIds
        requiredDocumentOwnerNames
      }
      kybRequirements {
        missingFields
        requiredDocuments
        requiredDocumentIds
        requiredDocumentOwnerNames
      }
      valid
      pending
    }
  }
`;

export const GET_APPLICATION_TAGS = gql`
  query VaultUnitApplicationTagsFetch($unitApplicationId: ID!) {
    vaultUnitApplicationTagsFetch(unitApplicationId: $unitApplicationId)
  }
`;
